module.exports = __webpack_public_path__ + "static/media/interested.de20d645.svg";